import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { MessageSquare, Image, FileText, Mic, Video, MapPin, User, Settings } from 'lucide-react';

interface SendMessageNodeData {
  title?: string;
  message?: string;
  messageType?: string;
  mediaUrl?: string;
  color?: string;
  tags?: string[];
}

export const SendMessageNode = memo(({ data, isConnectable }: NodeProps<SendMessageNodeData>) => {
  const getMessageTypeIcon = () => {
    switch (data.messageType) {
      case 'image':
        return <Image className="h-4 w-4 mr-1 text-emerald-600" />;
      case 'document':
        return <FileText className="h-4 w-4 mr-1 text-blue-600" />;
      case 'audio':
        return <Mic className="h-4 w-4 mr-1 text-purple-600" />;
      case 'video':
        return <Video className="h-4 w-4 mr-1 text-red-600" />;
      case 'location':
        return <MapPin className="h-4 w-4 mr-1 text-amber-600" />;
      case 'contact':
        return <User className="h-4 w-4 mr-1 text-gray-600" />;
      default:
        return <MessageSquare className="h-4 w-4 mr-1 text-emerald-600" />;
    }
  };

  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-emerald-200 hover:border-emerald-400 transition-colors duration-300">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-emerald-500"
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <MessageSquare className="h-4 w-4 mr-2" style={{ color: data.color || '#10b981' }} />
          <div className="text-sm font-medium text-gray-900">
            {data.title || 'Enviar mensaje'}
          </div>
        </div>
        <Settings className="h-4 w-4 text-gray-400" />
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <div className="flex items-center text-xs text-gray-500 mb-1">
          {getMessageTypeIcon()}
          <span className="font-medium">{data.messageType || 'Texto'}</span>
        </div>
        <div className="text-sm max-h-16 overflow-hidden text-ellipsis">
          {data.message || 'Sin mensaje configurado'}
        </div>
        {data.mediaUrl && (
          <div className="mt-1 text-xs text-gray-500 truncate">
            URL: {data.mediaUrl}
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="default"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-emerald-500"
      />
    </div>
  );
});

SendMessageNode.displayName = 'SendMessageNode';